import { t } from "i18next";
import { Fragment } from "react/jsx-runtime";

import { computationOptions } from "#app/computationOptions";
import { QuoteRequestLineDto } from "#modules/quoteRequestLines/infra/fetchQuoteRequestLine.api";
import { ProcessStepFromQuoteRequestLine } from "#modules/similarPart/view/clustering/CompareCard";
import { ProcessStepsCategory } from "#modules/similarPart/view/clustering/ProcessStepsCategory";
import { Flex } from "#shared/view/components/Flex";
import { Text } from "#shared/view/components/Text";
import {
  computeMaterialPrice,
  formatPriceString,
  isProductProcessStep,
  NO_OPTIMIZED_MATERIAL_COSTS,
} from "shared";

export const ClusterCardCosts = ({
  quoteRequestLine,
  sourceQuoteRequestLine,
  processSteps,
  quantity,
}: {
  quoteRequestLine: QuoteRequestLineDto | undefined | null;
  sourceQuoteRequestLine: QuoteRequestLineDto;
  processSteps: ProcessStepFromQuoteRequestLine[];
  quantity: number;
}) => {
  if (!quoteRequestLine) {
    return null;
  }

  const { partMaterialCost } = computeMaterialPrice(
    {
      quoteRequestLine,
      optimizedMaterialCosts: NO_OPTIMIZED_MATERIAL_COSTS,
    },
    computationOptions,
  );

  const valueAddedProcessSteps = processSteps.filter((ps) => !isProductProcessStep(ps));

  const productsProcessSteps = processSteps.filter((ps) => isProductProcessStep(ps));

  return (
    <Fragment>
      <Flex justify={"space-between"} align={"center"}>
        <Text>Coût Matière :</Text>
        <Text>
          {formatPriceString({
            amount: partMaterialCost / 100,
            config: {
              minimumFractionDigits: 0,
              maximumFractionDigits: 2,
            },
          })}
        </Text>
      </Flex>

      <ProcessStepsCategory
        title={`${t("quoteRequestLine.addedValueCost")} :`}
        processSteps={valueAddedProcessSteps}
        quantity={quantity}
        quoteRequestLine={quoteRequestLine}
        sourceQuoteRequestLine={sourceQuoteRequestLine}
      />

      <ProcessStepsCategory
        title={`${t("quoteRequestLine.purchases.cost")} :`}
        processSteps={productsProcessSteps}
        quantity={quantity}
        quoteRequestLine={quoteRequestLine}
        sourceQuoteRequestLine={sourceQuoteRequestLine}
      />
    </Fragment>
  );
};
